// DEV MODE: Set to true to bypass Okta authentication for testing
export const BYPASS_AUTH = false;

export const config = {
  oidc: {
    clientId: '0oadbivwlohfcQmSL0i7',
    issuer: 'https://grdf.okta-emea.com/oauth2/aus3k8giyen6PW0700i7',
    redirectUri: window.location.origin,
    scopes: ['openid', 'profile', 'email'],
    responseType: ['id_token', 'token','refresh_token'],
    pkce: true,
    nonce : "Rdg-auth0",
  }
};


// Mock user for development/testing
// Modifier 'roles' pour tester différents scénarios :
// ['ROLE_USER'] → accès application uniquement (aucun module)
// ['ROLE_RDG'] → accès RDG uniquement
// ['ROLE_RCG_PRESTA'] → accès RCG uniquement
// ['ROLE_AGENT_GRDF'] → accès complet
export const mockUser = {
  firstName: 'Test',
  lastName: 'User',
  email: 'test@grdf.fr',
  id: 'dev-user-123',
  roles: ['ROLE_AGENT_GRDF'],
};
